import React, { PropTypes } from 'react';
import classnames from 'classnames';

const DonnutChart = ({ percentage, containerClass, chartClass, children }) => {
  const rotation = Math.floor(percentage);
  const percentClass = `p${rotation}`;


  return (
    <div className={containerClass}>
      <div className={classnames('radial-progress c100', percentClass, chartClass)}>

        { children }

        <div className="slice">
          <div className="bar" />
          <div className="fill" />
        </div>

    </div>
  </div>);
};


DonnutChart.propTypes = {
  percentage: PropTypes.number.isRequired,
  containerClass: PropTypes.string,
  chartClass: PropTypes.string
};

export default DonnutChart;
